var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftOfficeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n        \t\t.cls-1{\n\t\t\t\t\tisolation:isolate;\n\t\t\t\t}\n\n\t\t\t\t.cls-2{\n\t\t\t\t\topacity:0.2;\n\t\t\t\t}\n\n\t\t\t\t.cls-2,.cls-3,.cls-5{\n\t\t\t\t\tmix-blend-mode:multiply;\n\t\t\t\t}\n\n\t\t\t\t.cls-4{\n\t\t\t\t\tfill:#fff;\n\t\t\t\t}\n\n\t\t\t\t.cls-5{\n\t\t\t\t\topacity:0.12;\n\t\t\t\t}\n\n\t\t\t\t.cls-6{\n\t\t\t\t\tfill:url(#linear-gradient);\n\t\t\t\t}\n\n\t\t\t\t.cls-7{\n\t\t\t\t\tfill:url(#linear-gradient-2);\n\t\t\t\t}\n\n\t\t\t\t.cls-8{\n\t\t\t\t\tfill:url(#linear-gradient-3);\n\t\t\t\t}\n\n\t\t\t\t.cls-9{\n\t\t\t\t\tfill:url(#linear-gradient-4);\n\t\t\t\t}\n\n\t\t\t\t.cls-10{\n\t\t\t\t\tfill:url(#linear-gradient-5);\n\t\t\t\t}\n\n\t\t\t\t.cls-11{\n\t\t\t\t\tfill:none;\n\t\t\t\t}\n\t\t"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 45.2,
    y1: -1.42,
    x2: 45.2,
    y2: 57.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ef8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e25c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#db4401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d83b01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 34.52,
    y1: 0.67,
    x2: 3.16,
    y2: 45.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#800600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c72127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#c13959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#bc4b81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#b95799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b85ba2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 18.5,
    y1: 55.63,
    x2: 59.44,
    y2: 55.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f32b44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a4070a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 35.16,
    y1: -0.24,
    x2: 28.52,
    y2: 9.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 46.32,
    y1: 56.55,
    x2: 27.99,
    y2: 54.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_-_Color",
    "data-name": "Icons - Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_-_Full_Bleed",
    "data-name": "Desktop - Full Bleed"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.93,49a3.22,3.22,0,0,0-1.59,6L29.7,61.44a6.2,6.2,0,0,0,3.07.81A6,6,0,0,0,34.48,62l17.09-4.87A6.12,6.12,0,0,0,56,51.26V49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.93,49a3.22,3.22,0,0,0-1.59,6L29.7,61.44a6.2,6.2,0,0,0,3.07.81A6,6,0,0,0,34.48,62l17.09-4.87A6.12,6.12,0,0,0,56,51.26V49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34.41,2,39,12.5V49L34.48,62l17.09-4.87A6.12,6.12,0,0,0,56,51.26V12.74a6.11,6.11,0,0,0-4.44-5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M12.74,48.61l5-2.7A4.36,4.36,0,0,0,20,42.08V22.43a4.37,4.37,0,0,1,2.87-4.1L39,12.5V8.07A6.32,6.32,0,0,0,34.41,2a6.18,6.18,0,0,0-1.73-.24h0a6.41,6.41,0,0,0-3.14.83L11.08,13.12A6.1,6.1,0,0,0,8,18.42V45.78A3.21,3.21,0,0,0,12.74,48.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M39,49H19.93a3.22,3.22,0,0,0-1.59,6L29.7,61.44a6.2,6.2,0,0,0,3.07.81h0A6,6,0,0,0,34.48,62,6.22,6.22,0,0,0,39,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M12.74,48.61l5-2.7A4.36,4.36,0,0,0,20,42.08V22.43a4.37,4.37,0,0,1,2.87-4.1L39,12.5V8.07A6.32,6.32,0,0,0,34.41,2a6.18,6.18,0,0,0-1.73-.24h0a6.41,6.41,0,0,0-3.14.83L11.08,13.12A6.1,6.1,0,0,0,8,18.42V45.78A3.21,3.21,0,0,0,12.74,48.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M39,49H19.93a3.22,3.22,0,0,0-1.59,6L29.7,61.44a6.2,6.2,0,0,0,3.07.81h0A6,6,0,0,0,34.48,62,6.22,6.22,0,0,0,39,56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    width: 64,
    height: 64
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOfficeLogo);
export default __webpack_public_path__ + "static/media/microsoft_office_logo.309ad3763b1b6ea133d4fdd62f2f9d37.svg";
export { ForwardRef as ReactComponent };